/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Status_Disruption_LabelInputs */



/**
* | output |
* | --- |
* | "Service disruption" |
*
* @param {System_Status_Disruption_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_disruption_label = /** @type {((inputs?: System_Status_Disruption_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Disruption_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dienststörung")
	return /** @type {LocalizedString} */ ("Service disruption")
});